
import React from "react";
import {ILatencyWrapper, ISampleRatesWrapper} from "../interfaces";


export interface ISampleRateLatencyProps {
    sampleRatesWrapper?:ISampleRatesWrapper,
    latencyWrapper?:ILatencyWrapper
}
/**
 * the entry point
 */
const TabSampleRateLatencyMobile = (props?: ISampleRateLatencyProps) => {

    /*const sampleRatesWrapper = props?.sampleRatesWrapper;*/
    let latencyWrapper = props?.latencyWrapper;
    const lt = latencyWrapper?.latency[0];

    return (
        <div className="my-4">
            {latencyWrapper != null && latencyWrapper.latency.length > 0 &&
                <ul className="bullet">
                {lt?.native44 && <li>44.1 kHz: <span dangerouslySetInnerHTML={{ __html: lt?.native44 ?? "" }} /> samples</li>}
                {lt?.native48 && <li>48 kHz: <span dangerouslySetInnerHTML={{ __html: lt?.native48 ?? "" }} /> samples</li>}
                {lt?.native88 && <li>88.2 kHz: <span dangerouslySetInnerHTML={{ __html: lt?.native88 ?? "" }} /> samples</li>}
                {lt?.native96 && <li>96 kHz: <span dangerouslySetInnerHTML={{ __html: lt?.native96 ?? "" }} /> samples</li>}
                {lt?.native176 && <li>176 kHz: <span dangerouslySetInnerHTML={{ __html: lt?.native176 ?? "" }} /> samples</li>}
                {lt?.native192 && <li>192 kHz: <span dangerouslySetInnerHTML={{ __html: lt?.native192 ?? "" }} /> samples</li>}
            </ul>}
        </div>
    )
};

export default TabSampleRateLatencyMobile;